import * as Scrivito from "scrivito";
import { getCategoryLabel } from "./_trainingUtils";
import TrainingCourseCard from "./TrainingCourseCard";
import TrainingCourseInfo from "./TrainingCourseInfo";
import { createTranslator } from "../../utils/translate";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

const TrainingCoursePage = ({ page }) => {
  const language = page.language() || "de";
  const t = createTranslator(language, translations);
  const categories = page.get("category") || [];
  const relatedCourses = (page.parent()?.children() || [])
    .filter(
      (c) =>
        c.objClass() === "TrainingCoursePage" &&
        c.id() !== page.id() &&
        (c.get("category") || []).some((k) => categories.includes(k))
    )
    .slice(0, 3);

  return (
    <div className="bg-lighter-gray">
      <div className="page-header-widget bg-blue">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="mb-2">
                {categories.map((k) => (
                  <span key={k} className="badge rounded-pill bg-blue me-1">
                    {getCategoryLabel(k, language)}
                  </span>
                ))}
              </div>
              {page.get("shortTitle") ? (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="shortTitle"
                />
              ) : (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="title"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="page-header_yellow_line" />

      <div className="container s-py-4">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="bg-white p-3 rounded">
              <Scrivito.ContentTag content={page} attribute="body" />
            </div>
          </div>

          <div className="col-12 col-md-4">
            <Scrivito.LinkTag
              className="btn bg-blue w-100 mb-3"
              to={page.parent()}
            >
              {t("backToCourseList")}
            </Scrivito.LinkTag>
            <TrainingCourseInfo page={page} language={language} />
          </div>
        </div>
      </div>

      {relatedCourses.length > 0 && (
        <div className="container s-py-4">
          <h2 className="mb-4">{t("relatedCourses")}</h2>
          <div className="row g-3">
            {relatedCourses.map((course) => (
              <div key={course.id()} className="col-12 col-md-4">
                <TrainingCourseCard course={course} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

Scrivito.provideComponent(
  "TrainingCoursePage",
  Scrivito.connect(TrainingCoursePage)
);
